import * as React from 'react';
import styled from 'styled-components';

import Typography from '@components/basics/typography';
import { rgba } from 'polished';
import colors from '@webapp/theme/colors';

const BackgroundColors = {
  'date-tier-1': rgba(colors.blues.blue1, 0.65),
  'date-tier-2': rgba(colors.blues.blue1, 0.45),
  'date-tier-3': rgba(colors.blues.blue1, 0.3),
  'date-tier-4': rgba(colors.blues.blue1, 0.15),
  'date-tier-5': rgba(colors.blues.blue1, 0.06),
};

const BackgroundColorsAfter = {
  'date-tier-1': rgba(colors.blues.blue1, 0.65),
  'date-tier-2': rgba(colors.blues.blue1, 0.45),
  'date-tier-3': rgba(colors.blues.blue1, 0.25),
  'date-tier-4': rgba(colors.blues.blue1, 0.15),
  'date-tier-5': rgba(colors.blues.blue1, 0.06),
};

const DatepickerPriceColors = {
  'date-tier-1': colors.whites.white1,
  'date-tier-2': colors.blacks.black3,
  'date-tier-3': colors.blacks.black3,
  'date-tier-4': colors.blacks.black3,
  'date-tier-5': colors.blacks.black3,
};

interface DatepickerPriceItemProps {
  className?: string;
  type: string;
  price: number;
  isSelected?: boolean;
  small?: boolean;
}

const DatepickerPriceItem: React.FC<DatepickerPriceItemProps> = (props) => {
  return (
    <Wrapper small={props.small} type={props.type} className={props.className}>
      <Typography className="datepicker-price" weight="700">
        ${Math.round(props.price / 100)}
      </Typography>
    </Wrapper>
  );
};

export default DatepickerPriceItem;

const Wrapper = styled.div<{ small?: boolean; type: string }>`
  padding: ${(props) => (props.small ? '5px 10px' : '10px')};
  ${(props) => (props.small ? null : 'padding-left: 20px')};
  ${(props) => (props.small ? null : 'padding-right: 20px')};
  border-radius: ${(props) => (props.small ? '9px' : '18px')};
  position: relative;
  text-align: center;
  background-color: ${({ type }) => BackgroundColors[type] ?? 'transparent'};

  transition: opacity
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  .datepicker-price {
    color: ${({ theme, type }) =>
      DatepickerPriceColors[type] ?? theme.colors.black};
  }

  &:after {
    background-color: ${({ type }) =>
      BackgroundColorsAfter[type] ?? 'transparent'};
  }

  /* ${(props) =>
    props.small
      ? ''
      : `
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 12px;
        transform: translate(0, -50%);
        height: 9px;
        width: 9px;
        border-radius: 50%;
      }
    `} */
`;
